import React, {useEffect} from 'react';
import {AutocompleteInput, InputProps, ReferenceInput} from 'react-admin';
import {useFormState, useForm} from 'react-final-form';

import {makeStyles} from '@material-ui/core/styles';

import UserQuickPreviewButton from './UserQuickPreviewButton';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
});

interface Props extends InputProps {
  reference: string;
}

const UserReferenceInput: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const {source} = props;
  const {values} = useFormState({subscription: {values: true}});
  const filterToQuery = (searchText: string) => ({
    key: searchText,
  });
  const form = useForm();
  const clearInput = () => form.change(source, undefined);

  useEffect(() => {
    // clear input field when changing community
    clearInput();
  }, [values?.community_id]);

  return (
    <div className={classes.root}>
      <div>
        <ReferenceInput filterToQuery={filterToQuery} {...props}>
          <AutocompleteInput optionText="fullname" optionValue="id" />
        </ReferenceInput>
      </div>
      {!!values[source] && <UserQuickPreviewButton id={values[source]} />}
    </div>
  );
};

export default UserReferenceInput;
